import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { Notify } from 'notiflix/build/notiflix-notify-aio';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  token?: string | null;
  constructor(private route: ActivatedRoute,
      private router: Router,
      private authService: AuthService) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      console.log(params);
      var data: any = {
        user_id: params["id"],
        token: params["t"]
      }
      this.router
          .navigate(['/home'], { queryParams: data })
          .then(() => { })
          .catch(() => { });
    });
    /*this.authService.checkReturnFromRequestPassword(this.token).subscribe(
        {
            next: this.handleActivateResponse.bind(this),
            error: this.handleError.bind(this)
        }
    )*/
  }

  handleActivateResponse(response: any): void {
      var x = response;
      this.router
          .navigate(['/home'])
          .then(() => { })
          .catch(() => { });
      Notify.success('User is now active', {
          position: 'right-top',
          timeout: 3000
      });
  }
  handleError(error: any): void {
      this.router
          .navigate(['/home'])
          .then(() => { })
          .catch(() => { });
      Notify.failure(error.error.message + '- Operation unsuccessful', {
          position: 'right-top',
          timeout: 3000
      });
  }
}